import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import CallToAction from '../widgets/CallToAction'
import { useContentfulMultipleEntry } from '../../hooks/useContentfulMultipleEntry'

function FourLinks({ section }) {
  // Extract item, items, zIndex from section prop
  const item = section?.fields ?? {};
  const items = section?.fields?.items ?? [];
  const zIndex = section?.zIndex;

  // Hydrate entries using useContentfulMultipleEntry
  const { entries, loading, error } = useContentfulMultipleEntry(items);

  if (loading || error || !entries) return null

  let topEdgeTopStyle = {
    paddingTop: '1rem',
    backgroundColor: '#f3f1e6' // To Do. Make these styles classes.
  }

  switch (item.roughEdgeTop) {
    case 'Off White Hero':
      topEdgeTopStyle = {
        marginTop: -80,
        paddingTop: 40,
        backgroundImage: `url("/images/rough-edge-off-white.png")`,
        backgroundRepeat: "no-repeat",
        zIndex: zIndex
      }
      break
    case 'Lime Green Hero':
      topEdgeTopStyle = {
        marginTop: -80,
        paddingTop: 40,
        backgroundImage: `url("/images/rough-edge-lime-green.png")`,
        backgroundRepeat: "no-repeat",
        zIndex: zIndex
      }
      break
    case 'Off White':
      topEdgeTopStyle = {
        marginTop: -30,
        paddingTop: 35,
        backgroundImage: `url("/images/rough-edge-off-white.png")`,
        backgroundRepeat: "no-repeat",
        zIndex: zIndex
      }
      break
    case 'Lime Green':
      topEdgeTopStyle = {
        marginTop: -30,
        paddingTop: 35,
        backgroundImage: `url("/images/rough-edge-lime-green.png")`,
        backgroundRepeat: "no-repeat",
        zIndex: zIndex
      }
      break
    default:
  }

  return (
    <Container id="four-links" fluid style={topEdgeTopStyle}>
      <Row className="four-links-content">
        {entries.map((entry, i) => {
          if (!entry || !entry.fields) return null

          let callToAction = entry.fields.displayCallToAction ?? false
          let url = false
          if (callToAction && entry.fields.callToActionArticle) {
            url = entry.fields.callToActionArticle.fields && entry.fields.callToActionArticle.fields.url ? entry.fields.callToActionArticle.fields.url : false
          }
          if (url && entry.fields.callToActionArticle.fields.type === 'Blog Post') {
            url = 'blog/' + url
          }
          if (url && entry.fields.callToActionArticle.fields.type === 'Event') {
            url = 'events/' + url
          }

          return (
            <Col xl={3} lg={6} md={6} sm={12} xs={12} key={i}>
              <table style={{ verticalAlign: 'bottom' }}>
                <tbody>
                  <tr>
                    <td width='95%'>
                      <CallToAction
                        internalLink={url}
                        externalLink={entry.fields.callToActionUrl}
                      >
                        <h2>{entry.fields.headline}</h2>
                      </CallToAction>
                    </td>
                    <td style={{ verticalAlign: 'top', textAlign: 'right' }}>
                      <CallToAction
                        internalLink={url}
                        externalLink={entry.fields.callToActionUrl}
                      >
                        <span className="fa-stack fa-2x" style={{ verticalAlign: 'bottom', marginBottom: '1rem' }}>
                          <i className="fas fa-circle fa-stack-2x"></i>
                          <i className="fas fa-arrow-right fa-stack-1x fa-inverse"></i>
                        </span>
                      </CallToAction>
                    </td>
                  </tr>
                  <tr>
                    <td className="tagline" style={{ verticalAlign: 'bottom' }}>
                      <p>{entry.fields.tagline}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </Col>
          )
        })}
      </Row>
    </Container>
  )
}

export default FourLinks;
